import { ComponentChildren } from 'preact'

export function isHtmlElement(el: EventTarget | null): el is HTMLElement {
  return !!el && 'dataset' in el
}

export function isInputEl(el: EventTarget | null): el is HTMLInputElement {
  return !!el && 'value' in el
}

export function isChangeEvent(e: Event): e is ChangeEvent {
  return !!e.target && 'value' in e.target
}

export function isInputClickEvent(e: Event): e is ClickEvent<HTMLInputElement> {
  return !!e.target && 'value' in e.target
}

export function isFunction(child: ComponentChildren): child is Function {
  return typeof child === 'function'
}

/**
 * @deprecated
 * In case of render props use a separate property for that
 */
export function getFirstChild<C>(children: C | C[]): C {
  return Array.isArray(children) ? children[0] : children
}
